import { noop } from 'lodash/fp';
import {
  useState,
  createContext,
  useContext,
  Dispatch,
  SetStateAction,
  ReactNode,
  ReactElement,
} from 'react';

interface IAlertState {
  alert: IAlert;
  setAlert: Dispatch<SetStateAction<IAlert>>;
}

interface IAlert {
  title: string;
  message: () => ReactElement;
  okAction: boolean;
  cancelAction: boolean;
  isOpen: boolean;
  isOk: boolean;
  onOk: () => void;
  onCancel: () => void;
  ackCheckBox?: boolean;
  ok?: () => ReactElement;
  cancelLabel: string;
}

interface IAlertContextProviderProps {
  defaults?: IAlert;
  children?: ReactNode;
}

export const defaultAlert: IAlert = {
  title: '',
  message: () => <></>,
  okAction: true,
  cancelAction: true,
  isOpen: false,
  isOk: false,
  onOk: noop,
  onCancel: noop,
  cancelLabel: 'cancel',
  ackCheckBox: false,
};

const defaultAlertState: IAlertState = {
  alert: defaultAlert,
  setAlert: () => void 0,
};

const AlertContext = createContext<IAlertState>(defaultAlertState);

export const useAlertContext = () => {
  return useContext(AlertContext);
};

export const AlertContextProvider = (props: IAlertContextProviderProps) => {
  const [alert, setAlert] = useState<IAlert>({
    ...defaultAlert,
    ...props.defaults,
  });

  return (
    <AlertContext.Provider
      value={{
        alert,
        setAlert,
      }}>
      {props.children}
    </AlertContext.Provider>
  );
};
